/** How far the mobile alert's bottom edge tucks behind the sheet below it. */
export const SHEET_OVERLAP_PX = 12;

export const DESKTOP_FOOTER_HEIGHT_PX = 32;

/** How far the map's bottom controls move up to clear the alert. */
export const STATUS_ALERT_CONTROLS_OFFSET_PX = {
  desktop: DESKTOP_FOOTER_HEIGHT_PX,
  mobile: 40,
};

export const STATUS_ALERT_TRANSITION_DURATION_MS = 200;
